// {
//   "isForty": 0,
//   "isTwenty": 0,
//   "isGame100": 0,
//   "modeID": 0,
//   "weaponType": "冲锋枪",
//   "is10WValue": 0,
//   "is15WValue": 0,
//   "is20WValue": 0
// }
import { MODE_OPTIONS } from './mode'
export const CHENGHAO_OPTIONS = [
  {
    keyName: 'isForty',
    pkeyName: 'defeatRate',
    name: '40%击败率',
    weight: 40,
    sort: 1,
  },
  {
    keyName: 'isTwenty',
    pkeyName: 'defeatRate',
    name: '20%击败率',
    weight: 20,
    sort: 2,
  },
  {
    keyName: 'isGame100',
    pkeyName: 'rank',
    name: '全模式排名前100',
    weight: 100,
    sort: 3,
  },
  {
    keyName: 'modeID-1',
    pkeyName: 'modeID',
    name: '最常游玩的模式',
    weight: 100,
    sort: 4,
  },
  {
    keyName: 'modeID-2',
    pkeyName: 'modeID',
    name: '最常游玩的模式',
    weight: 100,
    sort: 5,
  },
  {
    keyName: 'modeID-3',
    pkeyName: 'modeID',
    name: '最常游玩的模式',
    weight: 100,
    sort: 6,
  },
  {
    keyName: 'weaponType-1',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 7,
  },
  {
    keyName: 'weaponType-2',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 5,
  },
  {
    keyName: 'weaponType-3',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 6,
  },
  {
    keyName: 'weaponType-4',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 7,
  },
  {
    keyName: 'weaponType-5',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 8,
  },
  {
    keyName: 'weaponType-6',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 9,
  },
  {
    keyName: 'weaponType-7',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 10,
  },
  {
    keyName: 'weaponType-8',
    pkeyName: 'weaponType',
    name: '最常用武器类型',
    weight: 100,
    sort: 11,
  },
  {
    keyName: 'is20WValue',
    pkeyName: 'wValue',
    name: '超过20w时尚评分',
    weight: 20,
    sort: 6,
  },
  {
    keyName: 'is15WValue',
    pkeyName: 'wValue',
    name: '超过15w时尚评分',
    weight: 15,
    sort: 7,
  },
  {
    keyName: 'is10WValue',
    pkeyName: 'wValue',
    name: '超过10w时尚评分',
    weight: 10,
    sort: 8,
  },
]

export const WEAPON_TYPE_OPTIONS = [
  {
    cName: '突击步枪',
    key: 'SCAR',
    id: 1
  },
  {
    cName: '射手步枪',
    key: 'DMR',
    id: 2
  },
  {
    cName: '狙击步枪',
    key: 'SR',
    id: 3
  },
  {
    cName: '轻机枪',
    key: 'Light MG',
    id: 4
  },
  {
    cName: '冲锋枪',
    key: 'SMG',
    id: 5
  },
  {
    cName: '霰弹枪',
    key: 'Shotgun',
    id: 6
  },
  {
    cName: '重机枪',
    key: 'Heavy MG',
    id: 7
  },
  {
    cName: '近战武器',
    key: 'Melee',
    id: 8
  }
]

export const getWeaponTypeId = (cName) => {
  const weaponType = WEAPON_TYPE_OPTIONS.find(item => item.cName === cName)
  return weaponType ? weaponType.id : 0
}

export const getModeNum = (id) => {
  const mode = MODE_OPTIONS.find(item => item.id === id)
  return mode ? mode.num : 0
}

